// extracted by mini-css-extract-plugin
export default {"form":"EditTagForm_form__B4ZVA","editMode":"EditTagForm_editMode__ISuOz"};